module.exports = __webpack_public_path__ + "img/newtaiyo10.a5b1e363.png";